import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "text-center" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { class: "badge bg-primary-subtle text-primary border border-primary-subtle rounded-pill px-2 d-inline-flex align-items-center gap-2" }
const _hoisted_4 = {
  key: 1,
  class: "text-muted"
}

import { ref, computed, PropType } from "vue";
import { useStore } from "vuex";
import type { TelegramChannel } from "@/stores/telegramChannels";
import BaseChannelsTable from "./BaseChannelsTable.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'NetworkingChannelsTable',
  props: {
  channels: {
    type: Array as PropType<TelegramChannel[]>,
    required: true,
  },
  loading: {
    type: Boolean,
    default: false,
  },
},
  emits: ["edit", "delete", "create", "refresh", "update-order"],
  setup(__props) {

const props = __props;



const store = useStore();

const showInactive = ref(false);
const filteredChannels = computed(() => {
  if (showInactive.value) return props.channels;
  return props.channels.filter((c) => c.active);
});
const getRankName = (rankId: string) => {
  const getter = store.getters["ranks/rankName"];
  if (typeof getter === "function") {
    const name = getter(rankId);
    return name || rankId;
  }
  return rankId;
};

const rankIconClass = (rankId: string) => {
  const getter = store.getters["ranks/rankIconClass"];
  if (typeof getter === "function") {
    const icon = getter(rankId);
    return icon || "fas fa-trophy";
  }
  return "fas fa-trophy";
};

return (_ctx: any,_cache: any) => {
  const _component_rank_icon = _resolveComponent("rank-icon")!

  return (_openBlock(), _createBlock(BaseChannelsTable, {
    title: "Canales de Network Marketing",
    icon: "fa-users",
    iconClass: "",
    channels: filteredChannels.value,
    loading: __props.loading,
    "show-inactive": showInactive.value,
    "onUpdate:showInactive": _cache[0] || (_cache[0] = ($event: any) => ((showInactive).value = $event)),
    onEdit: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('edit', $event))),
    onDelete: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('delete', $event))),
    onCreate: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('create'))),
    onRefresh: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('refresh'))),
    onUpdateOrder: _cache[5] || (_cache[5] = ($event: any) => (_ctx.$emit('update-order', $event)))
  }, {
    headers: _withCtx(() => [...(_cache[6] || (_cache[6] = [
      _createElementVNode("th", { class: "py-3 text-center" }, "Rango Mínimo", -1)
    ]))]),
    row: _withCtx(({ channel }) => [
      _createElementVNode("td", _hoisted_1, [
        (channel.minRank)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createElementVNode("span", _hoisted_3, [
                _createVNode(_component_rank_icon, {
                  "icon-class": rankIconClass(channel.minRank),
                  "extra-class": "small"
                }, null, 8, ["icon-class"]),
                _createTextVNode(" " + _toDisplayString(getRankName(channel.minRank)), 1)
              ])
            ]))
          : (_openBlock(), _createElementBlock("span", _hoisted_4, "-"))
      ])
    ]),
    _: 1
  }, 8, ["channels", "loading", "show-inactive"]))
}
}

})